module.exports = __webpack_public_path__ + "img/09.c8b761be.png";